module.exports = __webpack_public_path__ + "static/img/20211211_4.58f2682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2021/20211211_4.png
// module id = mNnj
// module chunks = 0